import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'formly-field-readonly-input',
  template: `
    <ng-container *ngIf="currValue !== null && currValue !== undefined; else PLACEHOLDER">
      <span class="form-control wrapped-text" readonly="readonly" [class.auto-size]="autoHeight">
        <ng-container *ngIf="type && type === 'formatted-number'; else REGULAR">{{ currValue | localizedNumber: '1.0-0' }}</ng-container>
        <ng-template #REGULAR>
          <ng-container *ngIf="chips; else NORMAL">
            <span
              class="badge badge-primary badge-tag simple-tag"
              style="margin-top: -2px;"
              [class.mb]="autoHeight"
              *ngFor="let item of chipsList; let i = index"
              >{{ item }}</span
            >
          </ng-container>
          <ng-template #NORMAL>
            <ng-container *ngIf="props.dataPopup; else NO_POPUP">
              <span [innerHTML]="currValue" [pTooltip]="currValue" tooltipPosition="top" tooltipStyleClass="tooltip-min-width"></span>
            </ng-container>
          </ng-template>
          <ng-template #NO_POPUP>
            <span [innerHTML]="currValue"></span>
          </ng-template>
        </ng-template>
      </span>
    </ng-container>
    <ng-template #PLACEHOLDER>
      <span class="form-control hide-overflow" readonly="readonly" style="color: #495057">
        {{ placeholder | translate }}
      </span>
    </ng-template>
    <input type="text" readonly [value]="currValue" class="wcag-visuallyhidden" [id]="elementId" />
  `,
  styleUrls: ['./formly-custom-types.scss'],
})
export class FormlyFieldReadOnlyInputComponent extends FieldType implements OnInit {
  public translatePrefix;
  public type;
  public placeholder;
  public chips;
  public autoHeight;

  constructor(private translateService: TranslateService) {
    super();
  }

  ngOnInit() {
    this.translatePrefix = this.props.translatePrefix ? `${this.props.translatePrefix}.` : '';
    const placeholderText = !this.props.ignorePlaceholderTranslatePrefix ? `${ this.translatePrefix }${ this.props.placeholder }` : this.props.placeholder;
    this.props.placeholder && (this.placeholder = placeholderText);
   // this.props.placeholder && (this.placeholder = this.translateService.instant(`${this.props.placeholder}`));
    this.type = this.props.type;
    this.chips = this.props.chips;
    this.autoHeight = this.props.autoHeight;

    this.initDefaultValueSub();
  }

  get elementId(): string {
    if (this.field.id && this.field.id.includes('formly_')) {
      let prefix = this.form['id'];

      // check if in repeat section
      const parent = this.field.parent.parent;
      const grandParent = (parent && parent.parent) ? parent.parent : false;
      if (!prefix && parent && grandParent && grandParent.type === 'repeat') {
        const cnt = parent.key;
        prefix = `${grandParent['id']}_${cnt}`;
      }
      return `${prefix ? prefix + '_' : ''}${(this.key as string).replace('.', '_')}`;
    }
    return this.field.id;
  }

  get currValue() {
    const value = (this.formControl && this.formControl.value) || (this.model && this.model[this.field.key as string]);
    if (value) {
      const label = `${this.translatePrefix}${value}`;
      if (this.props.translate) {
        const translatedValue = value ? this.translateService.instant(label) : '';
        return translatedValue !== label ? translatedValue : value;
      }
    }
    return this.model && value;
  }

  get chipsList() {
    const value = this.model[this.field.key as string];
    return this.model && value && value.split(',');
  }

  private initDefaultValueSub(): void {
    const { defaultValue } = this.props;

    if (typeof defaultValue !== 'string' && typeof defaultValue !== 'number') {
      return;
    }

    const value = typeof defaultValue === 'number' ? defaultValue.toString() : defaultValue;

    this.formControl.setValue(value);
  }
}
